import React, { useEffect, useState } from 'react'
import Layout from '../../Layout/Layout'
import BillingDetails from './BillingDetails'
import Footer from '../../Layout/Footer'
import BillingDetails2 from './BillingDetails2'
import BillingDetails1 from './BillingDetails1'
import BillingDetails3 from './BillingDetails3'
import BillingDetailsAPI from './BillingDetailsAPI'
import BillingDetails1API from './BillingDetails1API'
import BillingDetails2API from './BillingDetails2API'
import Bills from './Bills'
import Billing from './Billing'
import Billing1 from './Billing1'
import Billing2 from './Billing2'
import Billing3 from './Billing3'
import BillingStatic from './BillingStatic'
import BillingDynamic from './BillingDynamic6'
// import FooterCalendar from '../../Layout/FooterCalendar'
import FooterNew from '../../Layout/FooterNew'
import SEO from '../../SEO'
import axios from 'axios'


const BASE_URL = "https://ecom.cyberathon.com/index.php/Api"; 
function Bill() {
const [seoData, setSeoData] = useState({});
  useEffect(() => {
    const fetchSeo = async () => {
      try {
        const response = await axios.post(`${BASE_URL}/get_seo_by_page`, {
          page_name: 'bill'   // <-- Important! page_name 'ebooks' rakho
        });
  
        if (response.data.status === 'true') {
          const data = response.data.data;
          setSeoData({
            title: data.meta_title,
            description: data.meta_description,
            keywords: data.meta_keywords,
            canonical: data.canonical_url,
          });
        }
      } catch (error) {
        console.error('SEO fetch error:', error);
      }
    };
  
    fetchSeo();
  }, []);

  return (

    <>
    <SEO
    title={seoData.title || "best cupping therapy tools ,authentic cupping supplies | shopeindia"}
    description={seoData.description || "ShopIndia is the best online shopping platform..."}
    keywords={seoData.keywords || "ShopIndia, online shopping, electronics, clothes, medicines"}
    canonical={seoData.canonical || "https://www.shopindia.com/"}
  />
    <Layout/>
    {/* <BillingDetails/> */}
    {/* <BillingDetails2/> */}
    {/* <BillingDetails1/> */}
    {/* <BillingDetails1API/> */}
    {/* <Bills/> */}
    
    {/* <Billing/> */}
    {/* <Billing2/> */}
    {/* <Billing3/> */}
    {/* <BillingStatic/> */}
<BillingDynamic/>
    {/* <Billing1/> */}
    {/* <BillingDetails2API/> */}
    {/* <BillingDetailsAPI/> */}
    {/* <BillingDetails3/> */}
    {/* <Footer/> */}
    {/* <FooterCalendar/> */}
    <FooterNew/>
    </>
  )
}

export default Bill
